import { selectTheme } from 'components/CustomerCards/CustomerCardsSearchBar';
import { SaleOrderStatus, SALE_ORDER_STATUSES } from 'models/sale-order';
import React, {PureComponent} from 'react';
import Button from 'react-bootstrap/Button';
import Select from 'react-select';
import { AuthenticationContext, CustomerPermission } from 'services/context/authentication.context';

export interface SaleOrdersSearchBarProps {
  status: SaleOrderStatus;
  selectedLocation?: string;
  locations: string[];
  onStatusChange: (status: any) => void;
  onLocationChange: (address: string | null) => void;
  onQuoteClick: () => void;
  onOrderClick: () => void;
}

export class SaleOrdersSearchBar extends PureComponent<SaleOrdersSearchBarProps, any> {
    static contextType = AuthenticationContext;

    render() {
        const { hasPermission } = this.context;

        return (
            <div className="bar-position">
                <h2>
                    Tellimused
                </h2>
                <div className="card mb-5">
                    <div className="card-body">
                      <div className='d-flex flex-wrap flex-md-nowrap flex-column flex-md-row justify-content-between'>
                        <div className="d-flex">
                          <Select
                            options={SALE_ORDER_STATUSES}
                            value={this.props.status as any}
                            onChange={(val) => this.props.onStatusChange(val)}
                            className='mw-240-px mr-md-4 mr-0 mt-2 mt-md-0 invoices__select'
                            placeholder='Vali staatus'
                            isClearable
                            theme={selectTheme}
                          />
                          <Select
                            options={this.props.locations.map(l => ({ label: l, value: l }))}
                            value={this.props.selectedLocation ? { value: this.props.selectedLocation, label: this.props.selectedLocation } : null}
                            onChange={(val: any) => this.props.onLocationChange(val?.value ?? null)}
                            className='mw-240-px mr-md-4 mr-0 mt-2 mt-md-0 invoices__select'
                            placeholder='Vali mahalaadimiskoht'
                            isClearable
                            theme={selectTheme}
                          />
                        </div>
                        {
                          hasPermission(CustomerPermission.WEB_ADMIN) && (
                            <div className="d-flex align-items-center">
                              <Button
                                variant="dark"
                                className="h-100 ml-auto"
                                type="button"
                                onClick={this.props.onQuoteClick}
                              >
                                <span className="px-3">
                                  Küsi hinnapakkumist
                                </span>
                              </Button>
                              <Button
                                variant="primary"
                                className="h-100 ml-3"
                                type="button"
                                onClick={this.props.onOrderClick}
                              >
                                <span className="px-3">
                                  Esita tellimus
                                </span>
                              </Button>
                            </div>
                          )
                        }
                      </div>
                    </div>
                </div>
            </div>
        )
    }
}